const VIEW = "View";
const EDIT = "Edit";
const DELETE = "Delete";
const CREATE = "Create";
const items = [
  {
    id: 1,
    name: "DASHBOARD",
    url: "/dashboard",
    icon: "icon-grid",
    permissionBaseName: "dashboard",
    capabilities: [
			{ id: 1, name: "dashboard_"+VIEW.toLowerCase(), label: VIEW, value: true,  },
		],
    attributes: { hidden: false },
    showed: false,
    selected: false,
  },
  {
    id: 2,
    name: "PRODUCTS",
    url: "/products",
    icon: "icon-badge",
    permissionBaseName: "product",
    capabilities: [
      { id: 1, name: "products_"+VIEW.toLowerCase(), label: VIEW, value: false },
      { id: 2, name: "products_"+EDIT.toLowerCase(), label: EDIT, value: false },
      { id: 3, name: "products_"+DELETE.toLowerCase(), label: DELETE, value: false },
			{ id: 4, name: "products_"+CREATE.toLowerCase(), label: CREATE, value: false },
    ],
    attributes: { hidden: false },
    showed: false,
    selected: false,
  },
  {
    id: 3,
    name: "CONNECTIONS",
    url: "/connections",
    icon: "icon-user",
    attributes: { hidden: false },
    children: [
      {
        id: 1,
        name: "Leads",
        url: "/connections/leads",
        icon: "icon-puzzle",
        permissionBaseName: "connectionLead",
        capabilities: [
          { id: 1, name: "leads_"+VIEW.toLowerCase(), label: VIEW, value: false },
          { id: 2, name: "leads_"+EDIT.toLowerCase(), label: EDIT, value: false },
          { id: 3, name: "leads_"+DELETE.toLowerCase(), label: DELETE, value: false },
					{ id: 4, name: "leads_"+CREATE.toLowerCase(), label: CREATE, value: false },
        ],
        attributes: { hidden: false },
        showed: false,
        selected: false,
      }
    ],
    showed: false,
    selected: false,
  },
  {
    id: 4,
    name: "WALLETS",
    url: "/wallets",
    icon: "icon-folder",
    attributes: { hidden: false },
    children: [
      {
        id: 1,
        name: "Manage Wallets",
        url: "/wallets",
        icon: "icon-grid",
        permissionBaseName: "wallet",
        capabilities: [
          { id: 1, name: "wallets_"+VIEW.toLowerCase(), label: VIEW, value: false },
          { id: 2, name: "wallets_"+EDIT.toLowerCase(), label: EDIT, value: false },
          { id: 3, name: "wallets_"+DELETE.toLowerCase(), label: DELETE, value: false },
					{ id: 4, name: "wallets_"+CREATE.toLowerCase(), label: CREATE, value: false },
        ],
        attributes: { hidden: false },
        showed: false,
        selected: false,
      },
      {
        id: 2,
        name: "Wallet Segments",
        url: "/wallet-segments/list",
        icon: "icon-grid",
        permissionBaseName: "walletSegment",
        capabilities: [
          { id: 1, name: "walletSegments_"+VIEW.toLowerCase(), label: VIEW, value: false },
          { id: 2, name: "walletSegments_"+EDIT.toLowerCase(), label: EDIT, value: false },
          { id: 3, name: "walletSegments_"+DELETE.toLowerCase(), label: DELETE, value: false },
					{ id: 4, name: "walletSegments_"+CREATE.toLowerCase(), label: CREATE, value: false },
        ],
        attributes: { hidden: false },
        showed: false,
        selected: false,
      },
      {
        id: 3,
        name: "QR codes",
        url: "/wallets/qrcodes",
        icon: "icon-grid",
        permissionBaseName: "walletQrCode",
        capabilities: [
          { id: 1, name: "qrCodes_"+VIEW.toLowerCase(), label: VIEW, value: false },
          { id: 2, name: "qrCodes_"+EDIT.toLowerCase(), label: EDIT, value: false },
          { id: 3, name: "qrCodes_"+DELETE.toLowerCase(), label: DELETE, value: false },
					{ id: 4, name: "qrCodes_"+CREATE.toLowerCase(), label: CREATE, value: false },
        ],
        attributes: { hidden: false },
        showed: false,
        selected: false,
      },
      {
        id: 4,
        name: "QR maker",
        url: "/wallets/qr-maker",
        icon: "icon-grid",
        permissionBaseName: "walletQrMaker",
        capabilities: [
          { id: 1, name: "qrcodeMaker_"+VIEW.toLowerCase(), label: VIEW, value: false },
          { id: 2, name: "qrcodeMaker_"+EDIT.toLowerCase(), label: EDIT, value: false },
          { id: 3, name: "qrcodeMaker_"+DELETE.toLowerCase(), label: DELETE, value: false },
					{ id: 4, name: "qrcodeMaker_"+CREATE.toLowerCase(), label: CREATE, value: false },
        ],
        attributes: { hidden: false },
        showed: false,
        selected: false,
      },
      {
        id: 5,
        name: "NFC chips",
        url: "/wallets/nfcChips",
        icon: "icon-puzzle",
        permissionBaseName: "walletNFCChip",
        capabilities: [
          { id: 1, name: "nfcChips_"+VIEW.toLowerCase(), label: VIEW, value: false },
          { id: 2, name: "nfcChips_"+EDIT.toLowerCase(), label: EDIT, value: false },
          { id: 3, name: "nfcChips_"+DELETE.toLowerCase(), label: DELETE, value: false },
					{ id: 4, name: "nfcChips_"+CREATE.toLowerCase(), label: CREATE, value: false },
        ],
        attributes: { hidden: false },
        showed: false,
        selected: false,
      }
    ],
    showed: false,
    selected: false,
  },
  {
    id: 5,
    name: "COMPONENTS",
    url: "/media",
    icon: "icon-puzzle",
    attributes: { hidden: false },
    children: [
      {
        id: 1,
        name: "Media Library",
        url: "/components/media",
        permissionBaseName: "componentMedia",
        icon: "icon-layers",
        capabilities: [
          { id: 1, name: "media_"+VIEW.toLowerCase(), label: VIEW, value: true },
          { id: 2, name: "media_"+EDIT.toLowerCase(), label: EDIT, value: true },
          { id: 3, name: "media_"+DELETE.toLowerCase(), label: DELETE, value: true },
					{ id: 4, name: "media_"+CREATE.toLowerCase(), label: CREATE, value: true },
        ],
        attributes: { hidden: false },
        showed: false,
        selected: false,
      },
      {
        id: 2,
        name: "Custom Fields",
        url: "/components/custom-fields",
        icon: "icon-screen-tablet",
        permissionBaseName: "componentCustomField",
        capabilities: [
          { id: 1, name: "customFields_"+VIEW.toLowerCase(), label: VIEW, value: false },
          { id: 2, name: "customFields_"+EDIT.toLowerCase(), label: EDIT, value: false },
          { id: 3, name: "customFields_"+DELETE.toLowerCase(), label: DELETE, value: false },
					{ id: 4, name: "customFields_"+CREATE.toLowerCase(), label: CREATE, value: false },
        ],
        attributes: { hidden: false },
        showed: false,
        selected: false,
      },
			{
        id: 3,
				name: "Forms",
				url: "/components/form-builder",
        icon: "icon-badge",
        permissionBaseName: "componentFormBuilder",
				capabilities: [
					{ id: 1, name: "formBuilder_"+VIEW.toLowerCase(), label: VIEW, value: false },
					{ id: 2, name: "formBuilder_"+EDIT.toLowerCase(), label: EDIT, value: false },
					{ id: 3, name: "formBuilder_"+DELETE.toLowerCase(), label: DELETE, value: false },
					{ id: 4, name: "formBuilder_"+CREATE.toLowerCase(), label: CREATE, value: false },
				],
        attributes: { hidden: false },
        showed: false,
        selected: false,
			},
			{
        id: 4,
				name: "Code Forms",
				url: "/components/code-builder",
        icon: "icon-bulb",
        permissionBaseName: "componentFormCodeBuilder",
				capabilities: [
					{ id: 1, name: "codeFormBuilder_"+VIEW.toLowerCase(), label: VIEW, value: false },
					{ id: 2, name: "codeFormBuilder_"+EDIT.toLowerCase(), label: EDIT, value: false },
					{ id: 3, name: "codeFormBuilder_"+DELETE.toLowerCase(), label: DELETE, value: false },
					{ id: 4, name: "codeFormBuilder_"+CREATE.toLowerCase(), label: CREATE, value: false },
				],
        attributes: { hidden: false },
        showed: false,
        selected: false,
			},
			{
        id: 5,
				name: "Image Forms",
				url: "/components/image-builder",
        icon: "icon-picture",
        permissionBaseName: "componentFormImageBuilder",
				capabilities: [
					{ id: 1, name: "imageFormBuilder_"+VIEW.toLowerCase(), label: VIEW, value: false },
					{ id: 2, name: "imageFormBuilder_"+EDIT.toLowerCase(), label: EDIT, value: false },
					{ id: 3, name: "imageFormBuilder_"+DELETE.toLowerCase(), label: DELETE, value: false },
					{ id: 4, name: "imageFormBuilder_"+CREATE.toLowerCase(), label: CREATE, value: false },
				],
        attributes: { hidden: false },
        showed: false,
        selected: false,
      },
      {
        name: 'Landing Pages',
        url: '/components/landing-pages',
        icon: 'icon-screen-tablet',
        permissionBaseName: "componentLandingPage",
				capabilities: [
					{ id: 1, name: "componentLandingPage_"+VIEW.toLowerCase(), label: VIEW, value: false },
					{ id: 2, name: "componentLandingPage_"+EDIT.toLowerCase(), label: EDIT, value: false },
					{ id: 3, name: "componentLandingPage_"+DELETE.toLowerCase(), label: DELETE, value: false },
					{ id: 4, name: "componentLandingPage_"+CREATE.toLowerCase(), label: CREATE, value: false },
				],
        attributes: { hidden: false },
        showed: false,
        selected: false,
      },
    ],
    showed: false,
    selected: false,
  },
  {
    id: 6,
    name: "CAMPAIGNS",
    url: "/campaigns",
    icon: "icon-globe",
    attributes: { hidden: false },
    children: [
      {
        id: 1,
        name: "Marketing",
        url: "/campaigns/marketing/list",
        icon: "icon-badge",
        permissionBaseName: "campaignMarketing",
        capabilities: [
					{ id: 1, name: "marketingCampaigns_"+VIEW.toLowerCase(), label: VIEW, value: false },
					{ id: 2, name: "marketingCampaigns_"+EDIT.toLowerCase(), label: EDIT, value: false },
					{ id: 3, name: "marketingCampaigns_"+DELETE.toLowerCase(), label: DELETE, value: false },
					{ id: 4, name: "marketingCampaigns_"+CREATE.toLowerCase(), label: CREATE, value: false },
        ],
        attributes: { hidden: false },
        showed: false,
        selected: false,
      },
      {
        id: 2,
        name: "Authentication",
        url: "/campaigns/authentication/list",
        icon: "icon-key",
        permissionBaseName: "campaignAuthentication",
        capabilities: [					
					{ id: 1, name: "authenticationCampaigns_"+VIEW.toLowerCase(), label: VIEW, value: false },
					{ id: 2, name: "authenticationCampaigns_"+EDIT.toLowerCase(), label: EDIT, value: false },
					{ id: 3, name: "authenticationCampaigns_"+DELETE.toLowerCase(), label: DELETE, value: false },
					{ id: 4, name: "authenticationCampaigns_"+CREATE.toLowerCase(), label: CREATE, value: false },
        ],
        attributes: { hidden: false },
        showed: false,
        selected: false,
      },
      {
        id: 3,
        name: "Track & Trace",
        url: "/campaigns/tracktrace/list",
        icon: "icon-location-pin",
        permissionBaseName: "campaignTracktrace",
        capabilities: [
					{ id: 1, name: "trackTraceCampaigns_"+VIEW.toLowerCase(), label: VIEW, value: false },
					{ id: 2, name: "trackTraceCampaigns_"+EDIT.toLowerCase(), label: EDIT, value: false },
					{ id: 3, name: "trackTraceCampaigns_"+DELETE.toLowerCase(), label: DELETE, value: false },
					{ id: 4, name: "trackTraceCampaigns_"+CREATE.toLowerCase(), label: CREATE, value: false },
        ],
        attributes: { hidden: false },
        showed: false,
        selected: false,
      },
      {
        id: 4,
        name: "Engagement",
        url: "/campaigns/engagement/list",
        icon: "icon-screen-smartphone",
        permissionBaseName: "campaignEngagement",
        capabilities: [
					{ id: 1, name: "engagementCampaigns_"+VIEW.toLowerCase(), label: VIEW, value: false },
					{ id: 2, name: "engagementCampaigns_"+EDIT.toLowerCase(), label: EDIT, value: false },
					{ id: 3, name: "engagementCampaigns_"+DELETE.toLowerCase(), label: DELETE, value: false },
					{ id: 4, name: "engagementCampaigns_"+CREATE.toLowerCase(), label: CREATE, value: false },
        ],
        attributes: { hidden: false },
        showed: false,
        selected: false,
      }
    ],
    showed: false,
    selected: false,
  },
  {
    id: 7,
    name: "ANALYTICS",
    url: "/analytics",
    icon: "icon-chart",
    permissionBaseName: "analytics",
    capabilities: [
			{ id: 1, name: "analytics_"+VIEW.toLowerCase(), label: VIEW, value: false },
			{ id: 2, name: "analytics_"+EDIT.toLowerCase(), label: EDIT, value: false },
			{ id: 3, name: "analytics_"+DELETE.toLowerCase(), label: DELETE, value: false },
			{ id: 4, name: "analytics_"+CREATE.toLowerCase(), label: CREATE, value: false },
    ],
    attributes: { hidden: false },
    showed: false,
    selected: false,
  },
  {
    id: 8,
    name: "FINANCIAL REPORTS",
    url: "/financial",
    icon: "icon-doc",
    permissionBaseName: "financialReport",
    capabilities: [
			{ id: 1, name: "financialReports_"+VIEW.toLowerCase(), label: VIEW, value: false },
			{ id: 2, name: "financialReports_"+EDIT.toLowerCase(), label: EDIT, value: false },
			{ id: 3, name: "financialReports_"+DELETE.toLowerCase(), label: DELETE, value: false },
			{ id: 4, name: "financialReports_"+CREATE.toLowerCase(), label: CREATE, value: false },
    ],
    attributes: { hidden: false },
    showed: false,
    selected: false,
  },
  {
    id: 9,
    name: "SETTINGS",
    url: "/settings",
    icon: "icon-settings",
    attributes: { hidden: false },
    children: [
      {
        id: 1,
        name: "Users",
        url: "/settings/users",
        icon: "icon-puzzle",
        permissionBaseName: "settingUser",
        capabilities: [		
					{ id: 1, name: "users_"+VIEW.toLowerCase(), label: VIEW, value: true },
					{ id: 2, name: "users_"+EDIT.toLowerCase(), label: EDIT, value: true },
					{ id: 3, name: "users_"+DELETE.toLowerCase(), label: DELETE, value: true },
					{ id: 4, name: "users_"+CREATE.toLowerCase(), label: CREATE, value: true },
        ],
        attributes: { hidden: false },
        showed: false,
        selected: false,
      },
      {
        id: 2,
        name: "Sales Agents",
        url: "/settings/salesAgents",
        icon: "icon-puzzle",
        permissionBaseName: "settingSaleAgent",
        capabilities: [
					{ id: 1, name: "salesAgents_"+VIEW.toLowerCase(), label: VIEW, value: false },
					{ id: 2, name: "salesAgents_"+EDIT.toLowerCase(), label: EDIT, value: false },
					{ id: 3, name: "salesAgents_"+DELETE.toLowerCase(), label: DELETE, value: false },
					{ id: 4, name: "salesAgents_"+CREATE.toLowerCase(), label: CREATE, value: false },
        ],
        attributes: { hidden: false },
        showed: false,
        selected: false,
      },
      {
        id: 3,
        name: "Companies",
        url: "/settings/companies",
        icon: "icon-puzzle",
        permissionBaseName: "settingCompany",
        capabilities: [
					{ id: 1, name: "companies_"+VIEW.toLowerCase(), label: VIEW, value: true },
					{ id: 2, name: "companies_"+EDIT.toLowerCase(), label: EDIT, value: true },
					{ id: 3, name: "companies_"+DELETE.toLowerCase(), label: DELETE, value: true },
					{ id: 4, name: "companies_"+CREATE.toLowerCase(), label: CREATE, value: true },
        ],
        attributes: { hidden: false },
        showed: false,
        selected: false,
      },
      {
        id: 4,
        name: "Groups",
        url: "/settings/groups",
        icon: "icon-puzzle",
        permissionBaseName: "settingGroup",
        capabilities: [
					{ id: 1, name: "groups_"+VIEW.toLowerCase(), label: VIEW, value: false },
					{ id: 2, name: "groups_"+EDIT.toLowerCase(), label: EDIT, value: false },
					{ id: 3, name: "groups_"+DELETE.toLowerCase(), label: DELETE, value: false },
					{ id: 4, name: "groups_"+CREATE.toLowerCase(), label: CREATE, value: false },
        ],
        attributes: { hidden: false },
        showed: false,
        selected: false,
      },
      {
        id: 5,
        name: "Roles",
        url: "/settings/roles",
        icon: "icon-puzzle",
        permissionBaseName: "settingRole",
        capabilities: [
					{ id: 1, name: "roles_"+VIEW.toLowerCase(), label: VIEW, value: false },
					{ id: 2, name: "roles_"+EDIT.toLowerCase(), label: EDIT, value: false },
					{ id: 3, name: "roles_"+DELETE.toLowerCase(), label: DELETE, value: false },
					{ id: 4, name: "roles_"+CREATE.toLowerCase(), label: CREATE, value: false },
        ],
        attributes: { hidden: false },
        showed: false,
        selected: false,
      },
      {
        id: 6,
        name: "Email Templates",
        url: "/settings/email-templates",
        icon: "icon-layers",
        permissionBaseName: "settingEmailTemplate",
        capabilities: [
					{ id: 1, name: "emailTemplates_"+VIEW.toLowerCase(), label: VIEW, value: false },
					{ id: 2, name: "emailTemplates_"+EDIT.toLowerCase(), label: EDIT, value: false },
					{ id: 3, name: "emailTemplates_"+DELETE.toLowerCase(), label: DELETE, value: false },
					{ id: 4, name: "emailTemplates_"+CREATE.toLowerCase(), label: CREATE, value: false },
        ],
        attributes: { hidden: false },
        showed: false,
        selected: false,
      },
      {
        id: 7,
        name: "General Settings",
        url: "/settings/general-settings",
        icon: "icon-puzzle",
        permissionBaseName: "settingGeneralSetting",
        capabilities: [
					{ id: 1, name: "generalSettings_"+VIEW.toLowerCase(), label: VIEW, value: false },
					{ id: 2, name: "generalSettings_"+EDIT.toLowerCase(), label: EDIT, value: false },
					{ id: 3, name: "generalSettings_"+DELETE.toLowerCase(), label: DELETE, value: false },
					{ id: 4, name: "generalSettings_"+CREATE.toLowerCase(), label: CREATE, value: false },
        ],
        attributes: { hidden: false },
        showed: false,
        selected: false,
      }
    ],
    showed: false,
    selected: false,
  }
];

export default {
  items: items
};
